export default "__VITE_ASSET__e1459d98__"